const parsePositiveNumber = (value) => {
  const normalizedValue = String(value ?? '').replace(',', '.');
  const parsedValue = Number(normalizedValue);

  if (!Number.isFinite(parsedValue) || parsedValue <= 0) {
    return null;
  }

  return parsedValue;
};

const getMaterialPalletCount = (material) => {
  const directPallets = parsePositiveNumber(material?.numberPallets);
  if (directPallets !== null) {
    return directPallets;
  }

  const occupiedPallets = parsePositiveNumber(material?.occupiedPallets);
  if (occupiedPallets !== null) {
    return occupiedPallets;
  }

  const totalPallets = parsePositiveNumber(material?.totalPallets);
  if (totalPallets !== null) {
    return totalPallets;
  }

  const quantity = parsePositiveNumber(material?.quantity);
  const palletUnits = parsePositiveNumber(material?.palletUnits);
  if (quantity !== null && palletUnits !== null) {
    return quantity / palletUnits;
  }

  return 0;
};

const getOfferFreePalletsForUpsells = (offer) => {
  const numberOfTrips = parsePositiveNumber(offer?.delivery?.numberOfTrips);
  if (numberOfTrips === null) {
    return null;
  }

  const deliveryName = String(offer?.delivery?.name || '').toLowerCase();
  const deliveryBreakdown = offer?.delivery?.deliveryBreakdown || null;
  const breakdownTotalPallets = parsePositiveNumber(deliveryBreakdown?.totalPallets);
  const breakdownShalandaCapacity = parsePositiveNumber(deliveryBreakdown?.shalandaCapacity);
  const breakdownManipulatorCapacity = parsePositiveNumber(deliveryBreakdown?.manipulatorCapacity);
  const manipulatorGoesWithShalands = deliveryBreakdown?.manipulatorGoesWithShalands === true;

  const palletRows = (offer?.materials || []).filter((material) => getMaterialPalletCount(material) > 0);
  if (palletRows.length === 0) {
    return null;
  }

  const occupiedTotal = breakdownTotalPallets !== null
    ? breakdownTotalPallets
    : palletRows.reduce((sum, material) => sum + getMaterialPalletCount(material), 0);

  let totalCapacity = null;

  if (deliveryName.includes('шаланд') && breakdownShalandaCapacity !== null) {
    totalCapacity = numberOfTrips * breakdownShalandaCapacity;

    if (manipulatorGoesWithShalands && breakdownManipulatorCapacity !== null) {
      totalCapacity += breakdownManipulatorCapacity;
    }
  } else if (deliveryName.includes('манипулятор') && breakdownManipulatorCapacity !== null) {
    totalCapacity = numberOfTrips * breakdownManipulatorCapacity;
  }

  if (totalCapacity === null || totalCapacity <= 0) {
    const capacityPerTrip = palletRows
      .map((material) => parsePositiveNumber(material?.totalPallets))
      .find((value) => value !== null);

    if (capacityPerTrip !== undefined) {
      totalCapacity = numberOfTrips * capacityPerTrip;
    }
  }

  if (totalCapacity === null || totalCapacity <= 0) {
    return null;
  }

  return Math.max(totalCapacity - occupiedTotal, 0);
};

const isSupportedUpsellForLoadingNorm = (item) => {
  const category = String(item?.category || '').trim().toLowerCase();
  return category === 'клей' || category.startsWith('u-блок');
};

const getUpsellUnitsPerPallet = (item) => {
  const unitsPerPallet = parsePositiveNumber(
    item?.unitsPerPallet ?? item?.units_per_pallet ?? item?.UNITS_PER_PALLET
  );
  if (unitsPerPallet !== null) {
    return unitsPerPallet;
  }

  const palletUnits = parsePositiveNumber(item?.palletUnits ?? item?.pallet_units);
  if (palletUnits !== null) {
    return palletUnits;
  }

  return null;
};

const formatLoadingNormNumber = (value) => {
  const normalizedValue = Number(value || 0);
  if (!Number.isFinite(normalizedValue)) {
    return '0';
  }

  if (normalizedValue % 1 === 0) {
    return String(normalizedValue);
  }

  return normalizedValue.toFixed(3).replace(/\.?0+$/, '');
};

const buildUpsellLoadingNorm = (item, freePallets) => {
  if (!isSupportedUpsellForLoadingNorm(item)) {
    return null;
  }

  if (!Number.isFinite(freePallets) || freePallets < 0) {
    return null;
  }

  const unitsPerPallet = getUpsellUnitsPerPallet(item);
  if (unitsPerPallet === null) {
    return null;
  }

  const addableQuantity = Math.floor(freePallets * unitsPerPallet);

  return {
    addableQuantity,
    freePallets,
    text: `До полной загрузки: ${formatLoadingNormNumber(addableQuantity)} шт | ${formatLoadingNormNumber(freePallets)} поддона`,
  };
};

export {
  buildUpsellLoadingNorm,
  getOfferFreePalletsForUpsells,
};
